// Copyright © Veeam Software Group GmbH

import resController from 'infrastructure/resources';

export const noTextWrap = (value: string | undefined): string => value || resController.current.components.dataGridCells.noText;
